import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            organizationsQuery: 'e/organizations/query',
            isLoaderActive: 'e/pages/isLoaderActive',
        }),
    },
    methods: {
        ...mapActions({
            fetchOrganizations: 'e/organizations/fetchItems',
        }),
        fetchOrganizationsIfNeeded() {
            return new Promise((resolve, reject) => {
                if (!this.isLoaderActive('organizations.fetchItems') && this.organizationsQuery().count() < 300) {
                    return this.fetchOrganizations().then(resolve)
                } else {
                    resolve()
                }
            })

        }
    },
}